export default "__VITE_ASSET__8a2ac80e__"